import { ConfirmAction, Heading, HeadingCaption } from 'idsk-react-components';
import React, { ReactElement } from 'react';
import { BackButton, BackLink } from 'slovlex-idsk-react-components';
import SuccessMessages from '../SuccessMessages';
import './pageHeadingWithBackButton.scss';

interface Props {
  heading?: string;
  headingCaption?: string;
  backLinkRoute?: string;
  backLinkText?: string;
  withBackLink?: boolean;
}

const PageHeadingWithBackButton = ({
  heading,
  headingCaption,
  backLinkRoute,
  backLinkText,
  withBackLink = false,
}: Props): ReactElement => {
  function backButton(): ReactElement {
    if (withBackLink) {
      return (
        <BackButton buttonStyle="link" />
      );
    }

    if (backLinkText && backLinkRoute) {
      return (
        <BackLink to={backLinkRoute}>{backLinkText}</BackLink>
      );
    }

    return <></>;
  }

  return (
    <div className="tezaurus-page-heading">
      <SuccessMessages />
      <ConfirmAction />
      {(backLinkText || withBackLink) && (
        <div className="back-button">
          {backButton()}
        </div>
      )}
      {headingCaption && (
        <HeadingCaption size="xl" className="tezaurus-page-caption">{headingCaption}</HeadingCaption>
      )}
      {heading && (
        <Heading size="xl" className="page-title">{heading}</Heading>
      )}
    </div>
  );
};

export default PageHeadingWithBackButton;
